import axios from 'axios';
import {clarify} from "@/utils/clear";

class SecUserApi {
    constructor() {
        this.endpoint = process.env.VUE_APP_BASE_API;
    }

    list(body) {
        let params = new URLSearchParams(clarify(body));
        return axios.get(`${this.endpoint}/sec/users`, {params}).then(response => response.data);
    }

    pagedList(body) {
        let params = new URLSearchParams(clarify(body));
        return axios.get(`${this.endpoint}/sec/users/paged`, {params}).then(response => response.data);
    }

    save(user) {
        return axios.post(`${this.endpoint}/sec/users/save`, user).then(response => response.data);
    }

    uploadExcel(f) {
        const formData = new FormData();
        formData.append('file', f);
        return axios.post(`${this.endpoint}/sec/users/upload/excel`, formData, {headers: {'Content-Type': 'multipart/form-data'}}).then(response => response.data);
    }

    get(userId) {
        return axios.get(`${this.endpoint}/sec/users/${userId}`, {}).then(response => response.data);
    }

    excel(body, prefix, suffix) {
        let params = new URLSearchParams(clarify(body));
        return axios.get(`${this.endpoint}/sec/users/download/excel`, {
            params,
            responseType: 'arraybuffer',
            headers: {
                'Accept': 'application/vnd.ms-excel'
            }
        }).then(response => {
            const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
            const link = document.createElement('a')
            link.href = URL.createObjectURL(blob)

            link.download = prefix + ' 회원목록'+suffix+'.xlsx'
            link.click()
            URL.revokeObjectURL(link.href)
        });

    }

    delete(userId) {
        return axios.delete(`${this.endpoint}/sec/users/delete?userId=${userId}`, {}).then(response => response.data);
    }
}


export default new SecUserApi();
